import ApiService from './ApiService';

export default class StudyFieldCategoriesService {
  static fetchByStudyField(studyField) {
    return ApiService.get(`/study-field-categories?studyField=${studyField}`);
  }

  static fetchByStudyFieldSlug(slug) {
    return ApiService.get(`/study-field-categories?studyFieldSlug=${slug}`);
  }

  static fetchAll() {
    return ApiService.get('/study-field-categories');
  }

  static fetchOne(slug) {
    return ApiService.get(`/study-field-categories/${slug}`);
  }
}
